<template>
  <d-card class="mb-4">
    <!-- Card Header -->
    <d-card-header
      class="border-bottom d-flex flex-row justify-content-between align-items-center bg-light"
    >
      <h6 class="m-0">Pickup Configuration</h6>
      <d-button
        size="sm"
        theme="danger"
        class="px-2 py-0"
        round
        @click="handleDelete"
      >
        Delete
      </d-button>
    </d-card-header>

    <d-list-group flush>
      <d-list-group-item class="px-0">
        <d-row class="border-bottom mx-0 pb-2">
          <d-col cols="6" md="4" lg="4" class="px-1 pb-1">
            <odd-label style="marginTop: 0 !important">Location Name</odd-label>
            <d-input
              type="text"
              :value="this.value.location"
              @input="i => handleUpdate('location', i)"
            />
          </d-col>
          <d-col cols="6" md="4" lg="4" class="px-1 pb-1">
            <odd-label style="marginTop: 0 !important">Address</odd-label>
            <d-input
              type="text"
              :value="this.value.address"
              @input="i => handleUpdate('address', i)"
            />
          </d-col>

          <d-col cols="6" md="4" lg="4" class="px-1 pb-1">
            <odd-label style="marginTop: 0 !important">City</odd-label>
            <d-input
              type="text"
              :value="this.value.city"
              @input="i => handleUpdate('city', i)"
            />
          </d-col>

          <d-col cols="6" md="4" lg="4" class="px-1 pb-1">
            <odd-label style="marginTop: 0 !important">State</odd-label>
            <d-select
              :value="this.value.state"
              :options="stateOptions"
              @input="i => handleUpdate('state', i)"
            >
            </d-select>
          </d-col>

          <d-col cols="6" md="4" lg="4" class="px-1 pb-1">
            <odd-label style="marginTop: 0 !important">Zip</odd-label>
            <d-input
              type="text"
              class="form-control"
              :value="this.value.postal"
              @input="i => handleUpdate('postal', i)"
            />
          </d-col>

          <d-col cols="6" md="4" lg="4" class="px-1 pb-1">
            <odd-label style="marginTop: 0 !important">Fee</odd-label>
            <currency-input
              :value="value.fee"
              class="form-control"
              @input="i => handleUpdate('fee', i)"
            />
          </d-col>
        </d-row>
        <d-row class="mx-0 pb-2">
          <d-col>
            <div class="p-2">
              <div
                v-for="d in this.value.pickup_dates"
                :key="d.id"
                class="d-inline"
              >
                <d-button
                  class="m-1 py-0 px-2"
                  round
                  size="sm"
                  :class="{
                    'btn-primary': active_pickup_date === d.id,
                    'btn-white': active_pickup_date !== d.id
                  }"
                  @click="handlePickupDateClick(d.id)"
                >
                  {{
                    DateTime.fromISO(d.date).toLocaleString(DateTime.DATE_SHORT)
                  }}
                </d-button>
                <d-button
                  v-show="active_pickup_date === d.id"
                  size="sm"
                  class="mr-1 py-0 px-2"
                  round
                  theme="danger"
                  type="button"
                  @click="handleRemovePickupDate(d.id)"
                  >X</d-button
                >
              </div>

              <d-form
                v-if="add_pickup_date"
                class="d-inline-flex flex-row align-items-center m-1"
                @submit="handleAddPickupDateSubmit"
              >
                <d-input
                  style="maxWidth: 140px; fontSize: .75rem; borderRadius: 1rem 0 0 1rem"
                  type="date"
                  round
                  class="radius-1 d-inline-block"
                  ref="add_pickup_date"
                  v-model="new_pickup_date"
                />
                <d-button
                  type="submit"
                  size="sm"
                  class="py-0 px-2"
                  style="borderRadius: 0 1rem 1rem 0"
                  >+</d-button
                >
              </d-form>
              <d-button
                v-show="!add_pickup_date"
                round
                size="sm"
                @click="showAddPickupDate"
                class="btn-success py-0 px-2 h-auto"
              >
                Add Pickup Date
              </d-button>
            </div>

            <d-form @submit="handleAddPickupTime">
              <table v-show="!!active_pickup_date" class="table mb-0 radius-10">
                <thead
                  class="bg-light"
                  style="borderTopLeftRadius: 1rem !important"
                >
                  <tr style="borderTopLeftRadius: 1rem !important">
                    <th scope="col" class="border-0 py-1">Start</th>
                    <th scope="col" class="border-0 py-1">End</th>
                    <th scope="col" class="border-0 py-1">Limit</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="pickup_time in show_pickup_times"
                    :key="pickup_time.id"
                  >
                    <td class="py-1 my-0">{{ pickup_time.start }}</td>
                    <td class="py-1 my-0">{{ pickup_time.end }}</td>
                    <td class="py-1 my-0">
                      <div class="d-flex flex-row justify-content-between">
                        <span>{{ pickup_time.limit }}</span>
                        <d-button
                          size="sm"
                          class="ml-2 py-0 px-2"
                          round
                          theme="danger"
                          type="button"
                          @click="handleRemovePickupTime(pickup_time.id)"
                          >X</d-button
                        >
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <d-input
                        v-model="new_start_time"
                        placeholder="start"
                        size="sm"
                        style="maxWidth: 125px"
                        class="radius-10"
                        type="time"
                      />
                    </td>
                    <td>
                      <d-input
                        v-model="new_end_time"
                        placeholder="end"
                        style="maxWidth: 125px"
                        size="sm"
                        class="radius-10"
                        type="time"
                      />
                    </td>
                    <td>
                      <div class="d-flex flex-row justify-content-between">
                        <d-input
                          type="text"
                          placeholder="limit"
                          style="maxWidth: 80px"
                          size="sm"
                          class="radius-10"
                          v-model="new_slot_limit"
                        />
                        <d-button
                          size="sm"
                          class="ml-2 py-0 px-2"
                          round
                          type="submit"
                          >Add</d-button
                        >
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </d-form>
          </d-col>
        </d-row>
      </d-list-group-item>
    </d-list-group>
  </d-card>
</template>

<script>
import { DateTime } from "luxon";
import { generateID } from "../utils/id";
import { USStates } from "../data/USStates";

export default {
  name: "pickup-configuration-card",
  data() {
    return {
      stateOptions: USStates.map(s => {
        return { text: s.name, value: s.abbreviation };
      }),
      DateTime,
      new_pickup_date: null,
      new_start_time: null,
      new_end_time: null,
      new_slot_limit: null,
      active_pickup_date: null,
      add_pickup_date: false
    };
  },
  props: {
    value: {}
  },
  watch: {
    value: { deep: true, handler: () => null }
  },
  mounted() {
    if (this.value.pickup_dates.length > 0)
      this.active_pickup_date = this.value.pickup_dates[0].id;
  },
  computed: {
    show_pickup_times() {
      return this.value.pickup_times.filter(
        p => p.date === this.active_pickup_date
      );
    }
  },
  methods: {
    handleUpdate(k, v) {
      const newValue = { ...this.value };
      newValue[k] = v;
      this.$emit("update", newValue);
    },
    handleDelete() {
      if (window.confirm("Are you sure?")) this.$emit("delete", this.value.id);
    },
    validate() {
      let errors = [];
      if (this.value.pickup_dates.length < 1) {
        errors.push("pickup");
      }
    },
    showAddPickupDate() {
      this.add_pickup_date = true;
      this.$nextTick(() => {
        this.$refs.add_pickup_date.$el.focus();
      });
    },
    handleRemovePickupTime(id) {
      this.handleUpdate(
        "pickup_times",
        this.value.pickup_times.filter(pt => pt.id !== id)
      );
    },
    handleRemovePickupDate(id) {
      this.handleUpdate(
        "pickup_dates",
        this.value.pickup_dates.filter(pd => pd.id !== id)
      );
    },
    handleAddPickupTime(event) {
      event.preventDefault();
      this.handleUpdate("pickup_times", [
        ...this.value.pickup_times,
        {
          id: generateID(),
          date: this.active_pickup_date,
          start: this.new_start_time,
          end: this.new_end_time,
          limit: this.new_slot_limit
        }
      ]);
    },
    handlePickupDateClick(id) {
      this.active_pickup_date = id;
    },
    handleAddPickupDateSubmit(event) {
      event.preventDefault();
      try {
        const date = DateTime.fromISO(this.new_pickup_date).toISODate();

        if (!!this.value.pickup_dates.find(pd => pd.date === date)) {
          alert("That Pickup Date Already Exists");
        } else if (!!!date) {
          alert("Invalid Date");
        } else {
          let id = generateID();
          this.handleUpdate("pickup_dates", [
            ...this.value.pickup_dates,
            { id, date }
          ]);
          this.$nextTick().then(() => {
            this.active_pickup_date = id;
            this.new_pickup_date = null;
            this.$refs.add_pickup_date.$el.focus();
          });
        }
      } catch (error) {
        console.log(error);
        alert("Invalid Date");
      }
    }
  }
};
</script>

<style></style>
